import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { ContextProvider } from 'Redux/context';
import GlobalStyle from './GlobalStyle';
import { store } from './Redux/store';
import Routes from './Routers/Routes';
import { MexlogTheme } from './Utils/Themes';
import { Toaster } from 'sonner';
import ReportJobsWidget from './Components/ReportJobsWidget';
import startAppUpdateWatcher from './Utils/appUpdateWatcher';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={MexlogTheme}>
        <GlobalStyle />
        <ContextProvider>
          <Routes />
          <Toaster />
          {/* Vive fuera del router: el avance de un reporte debe seguir
              visible aunque el usuario cambie de pantalla. */}
          <ReportJobsWidget />
        </ContextProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// Avisa al usuario cuando se publica un build nuevo y su pestaña sigue
// abierta con el bundle viejo. Va después del render para que el Toaster
// ya esté montado cuando haga falta mostrar el aviso.
startAppUpdateWatcher();
